export default __webpack_public_path__ + "static/media/business-3.dc338d04.jpg";